import { renameBucket } from "../../../services/api.js";

// Renames a bucket for the current user, moving every deed tagged with
// `from` to the bucket named `to`. One round-trip; atomic server-side.
//
// Throws if either side is empty or the sentinel "(none)" — renaming the
// no-bucket pseudo-group isn't supported by the rename endpoint (it would
// require bulk-assigning a bucket to every un-tagged deed, which is a
// different operation).
async function updateAllBuckets(from, to) {
  if (!from || from === "(none)") {
    throw new Error("Source bucket must be an existing bucket");
  }
  if (!to || to === "(none)") {
    throw new Error('Target bucket name cannot be empty or "(none)"');
  }

  const { data } = await renameBucket(from, to);
  return data;
}

export default updateAllBuckets;
